import "./general-info.scss";